import QuotationChange from '../models/Quotation/QuotationChange';

/**
 * Returns the date for the first change registered in the history array.
 *
 * @param changeHistory - The changes related to the specific quotation
 */
export function firstStatusChangeDate(
  changeHistory: QuotationChange[],
): string {
  const foundChange = changeHistory
    .filter((change): boolean => change.currentStatus === 0)
    .pop();
  if (foundChange) {
    return foundChange.createdAt;
  }
  return '';
}

/**
 * Returns the date related to the specific change id
 *
 * @param id - The status id to look for
 * @param changeHistory - Changes related to the quotation
 */
export function statusChangeDateForId(
  id: number,
  changeHistory: QuotationChange[],
): string {
  const foundChange = changeHistory
    .filter((change): boolean => change.currentStatus === id)
    .pop();
  if (foundChange) {
    return foundChange.createdAt;
  }
  return '';
}
